import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const connectionWizard: ThemeApp['appComponents']['connectionWizard'] = {
  components: {
    connectionWizard: {
      codeSnippetBox: {
        border: themeUi.semantic.color.border.secondary300,
        color: themeUi.semantic.color.text.secondary600
      },
      codeSnippetBoxContent: {
        fontFamily: themeUi.core.font.fontFamily.sourceCodeProRegular
      },
      highlightedPlaceholder: {
        color: themeUi.semantic.color.text.notice500
      },
      highlightedPlaceholderSecondary: {
        color: themeUi.semantic.color.text.secondary400
      },
      selectTrigger: {
        backgroundColor: themeUi.semantic.color.background.primary100
      },
      selectTriggerValue: {
        color: themeUi.semantic.color.text.primary400
      },
      label: {
        color: themeUi.semantic.color.text.secondary950
      }
    },

    connectionWizardCli: {
      separator: {
        backgroundColor: themeUi.semantic.color.background.neutral400
      }
    },

    connectionWizardClient: {
      separator: {
        backgroundColor: themeUi.semantic.color.background.secondary300
      }
    },

    copySnippet: {
      label: {
        color: themeUi.semantic.color.text.success500
      }
    },

    redisInsightConnection: {
      explanationHeader: {
        color: themeUi.semantic.color.text.secondary950
      },
      actionButtons: {
        borderTop: themeUi.semantic.color.border.neutral400
      }
    },

    setupConnectionMethod: {
      title: {
        color: themeUi.semantic.color.text.neutral800
      },
      description: {
        color: themeUi.semantic.color.text.neutral700
      }
    }
  }
};

export default connectionWizard;
